import { create } from "zustand";

import {
  closeSiblingDrawers,
  registerSidebarDrawer,
} from "./sidebar-drawer-coordinator";

interface PatientStatusDrawerState {
  isOpen: boolean;
  isLocked: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  lockDrawer: () => void;
}

export const usePatientStatusDrawerStore = create<PatientStatusDrawerState>(
  (set) => ({
    isOpen: false,
    isLocked: false,
    openDrawer: () => {
      closeSiblingDrawers("patient-status");
      set({ isOpen: true });
    },
    closeDrawer: () => set({ isOpen: false, isLocked: false }),
    lockDrawer: () => set({ isLocked: true }),
  }),
);

registerSidebarDrawer("patient-status", () =>
  usePatientStatusDrawerStore.getState().closeDrawer(),
);
